export const USER_DISPLAY_NAME = 'User_LABEL';

export const ACCOUNT_DISPLAY_NAME = 'Account_LABEL';

export const ROLE_DISPLAY_NAME = 'Role_LABEL';

export const ENTITLEMENT_DISPLAY_NAME = 'Ent_LABEL';

export const CHILD_ENTITLEMENT_DISPLAY_NAME = 'Ent2_LABEL';

export const EO_ACCOUNT_DISPLAY_NAME = 'Account_LABEL';
export const EO_ENTITLEMENT_DISPLAY_NAME = 'Ent_LABEL';
export const EO_CHILD_ENTITLEMENT_DISPLAY_NAME = 'Ent2_LABEL';

export const USER = 'User';
export const ROLE = 'Role';
export const ACCOUNT = 'Account';
export const ENTITLEMENT = 'Entitlement';
export const CHILD_ENTITLEMENT = 'Child Entitlement';
